'use strict';exports.__esModule = true;var getOpenedModalPropsInRoute = function getOpenedModalPropsInRoute(url) {return (
    url.split('/').filter(function (part) {return part.indexOf('pid') === 0;}));};exports.default =

getOpenedModalPropsInRoute;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/getOpenedModalPropsInRoute.js
// module id = 3158
// module chunks = 0